export interface IBaseSelectOption<T> extends IBaseOption {
  label: string;
  value: T;
  disabled?: boolean;
}

interface IBaseOption {
  [p: string]: any;
}
